import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { isMaintenance, isTestComponentAlwaysDisplay, forceAppShowApiKey, isDevelopmentEnvironment, isProductionEnvironment } from './config/envConfig';
import { GoogleOAuthProvider } from '@react-oauth/google';
import AppUser from './AppUser';
import ScrollToTopAuto from './shared/components/ScrollToTopAuto';

const App: React.FC = () => {

  return (
    <div className={`flex flex-col bg-gray-50`}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
        <Router>
          <ScrollToTopAuto />
          <AppUser />
        </Router>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;